import React from 'react';
import PropTypes from 'prop-types';
import useDataSourceContext from '@afosto/app-components-react/DataSource/useDataSourceContext';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import Icon from '@afosto/app-components-react/Icon';
import IconButton from '@material-ui/core/IconButton';
import { subtenants as subtenantsApi } from '@afosto/iam/api/Subtenants';
import translations from '../../translations';
import styled from 'styled-components';

const ActionButton = styled(IconButton)`
  && {
    &:last-child {
      margin-left: ${props => props.theme.spacing()}px;
    }
  }
`;

const RequestActions = ({ request }) => {
  const intl = useIntl();
  const { reloadDataSource } = useDataSourceContext();
  const { enqueueSnackbar } = useSnackbar();

  const handleRequest = state => async () => {
    try {
      await subtenantsApi.updateRequest(request.id, {
        state,
      });

      reloadDataSource();

      enqueueSnackbar(
        intl.formatMessage(
          translations.externalAccess.feedback[
            state === 'approved' ? 'requestApproved' : 'requestDeclined'
          ],
        ),
        {
          variant: 'success',
        },
      );
    } catch (err) {
      enqueueSnackbar(
        intl.formatMessage(
          translations.externalAccess.feedback[
            state === 'approved' ? 'requestNotApproved' : 'requestNotDeclined'
          ],
        ),
        {
          variant: 'error',
        },
      );
    }
  };

  return (
    <>
      <ActionButton onClick={handleRequest('approved')}>
        <Icon icon={['fal', 'check']} />
      </ActionButton>
      <ActionButton onClick={handleRequest('declined')}>
        <Icon icon={['fal', 'ban']} />
      </ActionButton>
    </>
  );
};

RequestActions.propTypes = {
  request: PropTypes.object,
};

RequestActions.defaultProps = {
  request: {},
};

export default RequestActions;
